module.exports = __webpack_public_path__ + "static/media/focus-icon-1.7896e4e6.webp";